import "react";
function isJsonObject(input) {
  return Object.prototype.toString.call(input) === "[object Object]";
}
function isUrlSearchParams(input) {
  return Object.prototype.toString.call(input) === "[object URLSearchParams]";
}
export {
  isJsonObject,
  isUrlSearchParams
};
//# sourceMappingURL=utils.js.map
